import styled, {css} from 'styled-components'
import CommonStyles from 'shared/style/commonPageStyles'

const Style = {
	Wrapper: CommonStyles.PageWrapper,
	AreaDiv: CommonStyles.AreaDivWithHeader,
	AreaHeader: CommonStyles.AreaHeader,
	ImgUploadDiv: CommonStyles.ImgUploadDiv,
	ImgElement: CommonStyles.ImgElement,

	SeriesDataDiv: styled.div`
		display: flex;
		flex-direction: column;
		gap: 4px;

		& > p {
			${({theme}) => theme.font.extra_small};
		}
	`,

	PrizeTable: styled.table`
		& > tr {
			& > td {
			}
		}
	`,
	TableHeader: styled.tr`
		background-color: ${({theme}) => theme.color.major};

		& > td {
			${({theme}) => theme.font.extra_small_bold};
			color: ${({theme}) => theme.color.white};
			padding: 12px 20px;
		}
	`,
	ElemTd: styled.td`
		border: 1px solid ${({theme}) => theme.color.grey2};
		background-color: ${({theme}) => theme.color.grey1};

		& > input {
			width: 100%;
			${({theme}) => theme.font.extra_small};
			padding: 12px 20px;

			${({$head}) =>
				$head &&
				css`
					background-color: ${({theme}) => theme.color.grey1};
					cursor: auto;
				`}
		}
	`,
	RankTd: styled.td`
		width: 200px;
		min-width: 200px;
	`,
	FitTd: styled.td`
		width: 100px;
		border: 1px solid ${({theme}) => theme.color.grey2};
	`,
	MoveTd: styled.td`
		width: 120px;
		border: 1px solid ${({theme}) => theme.color.grey2};
		> div {
			align-items: center;
			justify-content: center;
			display: flex;
			width: 100%;
		}
	`,
	ActionTd: styled.td`
		width: 280px;
		border: 1px solid ${({theme}) => theme.color.grey2};
		display: flex;
		gap: 10px;
		justify-content: center;
		align-items: center;
		padding: 5px 0;
	`,
	ControlDiv: styled(CommonStyles.ControlDiv)`
		& > div {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 24px;
			height: 24px;
			border-radius: 4px;
			background-color: ${({theme}) => theme.color.grey2};
		}
	`,
	AddBtn: CommonStyles.AddBtn,

	// Duration Input Styles - TODO: Remove after migration to shared component
	DurationInputWrapper: styled.div`
		display: flex;
		align-items: center;
		gap: 10px;
		margin-right: 20px;

		& > p {
			margin: 0;
			${({theme}) => theme.font.small_bold};
			color: ${({theme}) => theme.color.black};
		}

		& > input {
			width: 80px;
			padding: 8px 12px;
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;
			${({theme}) => theme.font.extra_small};
			background-color: ${({theme}) => theme.color.white};
			transition: border-color 0.2s ease;

			&:focus {
				outline: none;
				border-color: ${({theme}) => theme.color.major};
			}

			&::placeholder {
				color: ${({theme}) => theme.color.grey3};
			}

			&:hover {
				border-color: ${({theme}) => theme.color.grey4};
			}
		}
	`,
}

export default Style
